exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".style-module_spinner_lQOI8aQKg7AjMNYHPZEz0 {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  min-height: 100vh;\n}\n", "", {"version":3,"sources":["/root/app/src/components/OAuth2/Login/style.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;CACnB","file":"style.module.css","sourcesContent":[".spinner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  min-height: 100vh;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"spinner": "style-module_spinner_lQOI8aQKg7AjMNYHPZEz0"
};